/* eslint-disable curly */
import React from 'react';
import { TylerState } from '../utils/TylerState';

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  userEmail: string;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose, userEmail }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content welcome-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">🎉 Welcome to Larry's Help!</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          <div className="welcome-icon">👋</div>
          <h3>Hello, {userEmail.split('@')[0]}!</h3>
          <p>You're now part of the Larry's Help family! Get ready to take control of your financial future with our powerful tools.</p>
          
          <div className="welcome-features">
            <div className="feature-item">
              <span className="feature-icon">💾</span>
              <span>Save & organize your retirement scenarios</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🖨️</span>
              <span>Print professional reports to share</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📊</span>
              <span>Compare different financial strategies</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🎯</span>
              <span>Track your progress over time</span>
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '24px', opacity: 0.8 }}>
            <p style={{ fontSize: '0.9rem', margin: '0' }}>
              💡 <strong>Pro tip:</strong> Start with the Quick Start calculator to get familiar with the basics!
            </p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="modal-btn modal-btn-primary" onClick={onClose}>
            Let's Get Started! 🚀
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal; 